import React from "react";
import Container from "react-bootstrap/Container";

const Footer = (props) => {
  const bgStyle = { backgroundColor: "#E2E2E2" };

  return (
    <footer style={bgStyle} className="mt-auto py-5 text-center ">
      <Container>
      {props.children}
        <i className="fas fa-code" /> with <i className="fas fa-heart" /> by{" "}
        <a
          rel="noopener"
          href="https://github.com/ruoks"
          aria-label="My GitHub"
        > <span className="badge bg-dark">
            Rokas Kazlauskis
          </span>
        </a>{" "}
        using <i className="fab fa-react" />
      </Container>
    </footer>
  );
};

export default Footer;
